<template>
  <div id="app">
    <header-top></header-top>
    <template>
      <router-view></router-view>
    </template>
    <footer-content></footer-content>
  </div>
</template>
<script>
  import HeaderTop from './components/Header';
  import FooterContent from './components/FooterContent2'
  export default {
    name: 'App',
    components: {HeaderTop,FooterContent},
    data() {
      return {

      }
    }
  }
</script>
<style scoped lang="less" src="./style/index.less"></style>



// WEBPACK FOOTER //
// src/App.vue